export const SERVICE_RULE_DEFAULTS = {
  enabled: false,
  threshold_type: 'time' as const,
}

export const LOCATION_VIEW_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'Region', value: 'Region' },
  { label: 'State', value: 'State' },
]

export const DEFAULT_LOCATION_GROUP_BY = 'Region' as const

export const NIGHT_TIME_RANGE = '12PM-6AM'
export const WEEKEND_TIME_RANGE = 'Sat + Sun'

export const SETTINGS_DATA = [
  {
    title: 'Requires Approval',
    description: 'This accessorial requires approval before being applied',
    fieldName: 'requires_approval' as const,
  },
  {
    title: 'Exclude from Invoice',
    description: 'This accessorial will not appear on invoices',
    fieldName: 'exclude_from_invoice' as const,
  },
  {
    title: 'Link to Driver Special Pay',
    description: 'Automatically trigger driver special pay when this accessorial is applied',
    fieldName: 'link_to_special_pay' as const,
  },
]

export const DEFAULT_TIME_INTERVAL = 15

export const RATE_INTERVALS = [
  { label: '1 min', value: 1 },
  { label: '5 min', value: 5 },
  { label: '15 min', value: 15 },
  { label: '30 min', value: 30 },
  { label: '60 min', value: 60 },
]
